import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addITskill, deleteITskill, fetchCoreSkills, fetchITskills, updateITskill } from "./ITskillAPI";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchITskillsAsync = createAsyncThunk(
  "ITskills/fetch",
  async () => {
    try {
      const data = await fetchITskills();

      const resp = data?.response;
      console.log("resp IT", resp)
      return await resp;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);
export const fetchCoreSkillsAsync = createAsyncThunk(
  "Coreskills/fetch",
  async () => {
    try {
      const data = await fetchCoreSkills();

      const resp = data?.response;
      // console.log("resp core ", resp)
      return await resp;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);

export const deleteITskillAsync = createAsyncThunk(
  "ITskills/delete",
  async ({uuid}) => {
    try {
      await deleteITskill(uuid);
      return uuid;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);

export const updateITskillAsync = createAsyncThunk(
  "ITskills/update",
  async ({ uuid, ITskillData }) => {
    try {
      const response = await updateITskill( uuid, ITskillData);
      // console.log("Response Slice", response);
      return response;
    } catch (error) {
      // return rejectWithValue(error.message);
    }
  }
);

export const addITskillAsync = createAsyncThunk(
  "ITskills/add",
  async ({newITskill}) => {
    try {
      const data = await addITskill(newITskill);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);

const ITskillSlice = createSlice({
  name: "Projects",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchITskillsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchITskillsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchITskillsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      .addCase(fetchCoreSkillsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCoreSkillsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchCoreSkillsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addITskillAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(addITskillAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add project";
      })

      .addCase(updateITskillAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateITskillAsync.fulfilled, (state, action) => {
        state.loading = false;
      
        if (Array.isArray(state.data)) {
          const updatedProjectIndex = state.data.findIndex(
            (ITskillData) => ITskillData.uuid === action.payload.uuid
          );
      
          if (updatedProjectIndex !== -1) {
            state.data[updatedProjectIndex] = action.payload;
          }
        } else {
          state.data = [action.payload];
        }
      })
      
      .addCase(updateITskillAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update project";
      })
      
      .addCase(deleteITskillAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteITskillAsync.fulfilled, (state, action) => {
        state.loading = false;
        // Ensure state.data is an array before filtering
        if (Array.isArray(state.data)) {
          state.data = state.data.filter((ITskill) => ITskill.uuid !== action.payload);
        } else {
          console.error("state.data is not an array");
        }
      })
      .addCase(deleteITskillAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectITskills = (state) => state.ITskills.data?.it_skills;
export const selectCoreSkills = (state) => state.ITskills.data?.skills;

export default ITskillSlice.reducer;
